module.exports = __webpack_public_path__ + "static/img/Festival.fcf2ff5.png";